import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';


class ViewSolution extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Solution = null;

        if (this.props.Solution){
            this.data.Solution = this.props.Solution; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks; 
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Solution){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>
                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/solution/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'prefix') &&
                            <PD.Tr>                                
                                <PD.Th>Default Prefix</PD.Th><PD.Td>{json.prefix}</PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                        {json.Owner &&
                            <PD.Tr>
                                <PD.Th>Owner</PD.Th><PD.Td>{json.Owner.organisation}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Solution)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewSolution;